import {
    ADD_ITEM,
    CHANGE_ITEMS,
    CHANGE_TYPE,
    CLEAR_BASKET,
    DELETE_ITEM,
    DISPLAY_ALERT,
    EDIT_USER_SUCCESS,
    GET_CURRENT_USER_BEGIN,
    GET_CURRENT_USER_SUCCESS,
    LOADING_BEGIN,
    LOADING_ITEMS_ERROR,
    LOADING_ITEMS_SUCCESS,
    LOADING_SUCCESS,
    LOADING_TABLE_BEGIN,
    LOADING_TABLE_ERROR,
    LOADING_TABLE_SUCCESS,
    LOADING_USERS_SUCCESS,
    LOGIN_USER_ERROR,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    PROCESS_PAYMENT_SUCCESS,
    SELECT_TABLE,
    TABLE_SAVING_BEGIN,
    TABLE_SAVING_ERROR,
    TABLE_SAVING_SUCCESS,
    TOGGLE_MODAL,
    TOGGLE_PAYMENT_SCREEN,
    TOGGLE_TABLE_MENU,
    UPDATE_DESC,
    UPDATE_PRICE,
    UPDATE_QTY,
} from "./actions";

const reducer = (state, action) => {
    if (action.type === LOADING_BEGIN) {
        return {
            ...state,
            isLoading: true,
        };
    }
    if (action.type === LOADING_SUCCESS) {
        return {
            ...state,
            isLoading: false,
        };
    }

    if (action.type === LOGIN_USER_SUCCESS) {
        return {
            ...state,
            user: action.payload,
        };
    }
    if (action.type === LOGIN_USER_ERROR) {
        return {
            ...state,
            isLoading: false,
        };
    }
    if (action.type === DISPLAY_ALERT) {
        return {
            ...state,
            showAlert: true,
            alertType: "danger",
            alertText: "Please provide all values!",
        };
    }
    if (action.type === CHANGE_ITEMS) {
        return {
            ...state,
            displayItems: action.payload.items,
        };
    }
    if (action.type === CHANGE_TYPE) {
        return {
            ...state,
            currentCategory: action.payload.type,
        };
    }
    if (action.type === ADD_ITEM) {
        let index = state.basket.basketItems.findIndex((item) => item.id == action.payload.item.id);
        if (index != -1) {
            let newBasketItems = state.basket.basketItems.map((item) => {
                if (item.id === action.payload.item.id) {
                    return {
                        ...item,
                        quantity: item.quantity + 1,
                    };
                }
                return item;
            });
            return {
                ...state,
                basket: {
                    ...state.basket,
                    basketItems: newBasketItems,
                },
            };
        } else {
            return {
                ...state,
                basket: {
                    ...state.basket,
                    basketItems: [
                        ...state.basket.basketItems,
                        {
                            //Fix in the future
                            name: action.payload.item.name,
                            id: action.payload.item.id,
                            item: action.payload.item.id,
                            quantity: 1,
                            price: parseFloat(action.payload.item.price),
                            instruction: "",
                        },
                    ],
                },
            };
        }
    }

    if (action.type === UPDATE_PRICE) {
        const newPrice = state.basket.basketItems.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue.price * currentValue.quantity;
        }, 0);
        return {
            ...state,
            basket: {
                ...state.basket,
                TotalPrice: newPrice,
            },
        };
    }

    if (action.type === UPDATE_QTY) {
        const { id } = action.payload.obj;
        let newBasketItems;
        if (action.payload.operation === "increase") {
            newBasketItems = state.basket.basketItems.map((item) => {
                if (item.id === id) {
                    return {
                        ...item,
                        quantity: item.quantity + 1,
                    };
                }
                return item;
            });
        } else {
            newBasketItems = state.basket.basketItems.map((item) => {
                if (item.id === id) {
                    return {
                        ...item,
                        quantity: item.quantity - 1,
                    };
                }
                return item;
            });
        }
        return {
            ...state,
            basket: {
                ...state.basket,
                basketItems: newBasketItems,
            },
        };
    }

    if (action.type === DELETE_ITEM) {
        const newBasketItems = state.basketItems.filter((item) => item.id != action.payload.id);
        return {
            ...state,
            basket: {
                ...state.basket,
                basketItems: newBasketItems,
            },
        };
    }

    if (action.type === CLEAR_BASKET) {
        return {
            ...state,
            basket: {
                ...state.basket,
                basketItems: [],
            },
        };
    }
    if (action.type === TOGGLE_MODAL) {
        if (action.payload.command === "search") {
            return {
                ...state,
                modal: {
                    isOpen: !state.modal.isOpen,
                    editId: null,
                    function: "search",
                },
            };
        }
        if (action.payload.id) {
            return {
                ...state,
                modal: {
                    isOpen: !state.modal.isOpen,
                    editId: action.payload.id,
                },
            };
        } else {
            return {
                ...state,
                modal: {
                    isOpen: !state.modal.isOpen,
                    editId: null,
                },
            };
        }
    }

    if (action.type === UPDATE_DESC) {
        const newBasketItems = state.basket.basketItems.map((item) => {
            if (item.id === state.modal.editId) {
                return {
                    ...item,
                    instruction: action.payload.desc,
                };
            }
            return item;
        });
        return {
            ...state,
            basket: {
                ...state.basket,
                basketItems: newBasketItems,
            },
        };
    }

    if (action.type === SELECT_TABLE) {
        if (action.payload.id) {
            return {
                ...state,
                basket: {
                    ...state.basket,
                    tableNum: action.payload.id,
                },
            };
        } else {
            return {
                ...state,
                basket: {
                    ...state.basket,
                    tableNum: null,
                },
            };
        }
    }

    if (action.type === LOADING_ITEMS_SUCCESS) {
        let items = action.payload.data["items"];
        return {
            ...state,
            displayItems: items,
        };
    }
    if (action.type === LOADING_ITEMS_ERROR) {
        return {
            ...state,
            isLoading: false,
        };
    }

    if (action.type === LOADING_TABLE_BEGIN) {
        return {
            ...state,
            basket: {
                ...state.basket,
                isLoading: true,
            },
        };
    }
    if (action.type === LOADING_TABLE_SUCCESS) {
        let items = action.payload.data["items"][0]["items"];
        return {
            ...state,
            basket: {
                TotalPrice: 0,
                tableId: action.payload.data["items"][0]["id"],
                tableNum: action.payload.id,
                isLoading: false,
                basketItems: items,
            },
        };
    }
    if (action.type === LOADING_TABLE_ERROR) {
        return {
            ...state,
            isLoading: false,
        };
    }
    if (action.type === TOGGLE_TABLE_MENU) {
        return {
            ...state,
            displayItems: [],
            basket: {
                TotalPrice: 0,
                tableNum: null,
                isLoading: false,
                basketItems: [],
            },
        };
    }
    if (action.type === TABLE_SAVING_BEGIN) {
        return {
            ...state,
            basket: {
                isLoading: true,
                ...state.basket,
            },
        };
    }
    if (action.type === TABLE_SAVING_SUCCESS) {
        return {
            ...state,
            basket: {
                TotalPrice: 0,
                tableNum: null,
                basketItems: [],
                isLoading: false,
            },
        };
    }
    if (action.type === TABLE_SAVING_BEGIN) {
        return {
            ...state,
        };
    }
    if (action.type === GET_CURRENT_USER_BEGIN) {
        return {
            ...state,
            userLoading: true,
        };
    }
    if (action.type === GET_CURRENT_USER_SUCCESS) {
        return {
            ...state,
            userLoading: false,
            user: action.payload.user,
        };
    }
    if (action.type === LOGOUT_USER) {
        return {
            ...state,
            user: null,
            token: null,
        };
    }
    if (action.type === LOADING_USERS_SUCCESS) {
        return {
            ...state,
            displayItems: action.payload.data["user"],
        };
    }
    if (action.type === EDIT_USER_SUCCESS) {
        return {
            ...state,
            currentEdit: action.payload.data,
        };
    }
    if (action.type === TOGGLE_PAYMENT_SCREEN) {
        return {
            ...state,
            paymentScreen: !state.paymentScreen,
        };
    }
    if (action.type === PROCESS_PAYMENT_SUCCESS) {
        return {
            ...state,
            currentCategory: null,
        };
    }

    throw new Error(`no such action :${action.type}`);
};

export default reducer;
